export const OpenAnswer = () => {
  return <div><img src={process.env.PUBLIC_URL + "/pictos/reponse-libre.svg"} style={{width: "70%"}} alt={"Réponse libre"}/></div>;
};
